import { render, staticRenderFns } from "./WorkQueue.vue?vue&type=template&id=32462252&scoped=true&"
import script from "./WorkQueue.vue?vue&type=script&lang=js&"
export * from "./WorkQueue.vue?vue&type=script&lang=js&"
import style0 from "./WorkQueue.vue?vue&type=style&index=0&id=32462252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32462252",
  null
  
)

export default component.exports